// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"350":"72a30a16","443":"ad7f724d"}[chunkId] || chunkId) + "." + {"350":"8b896dedd634ebf4","443":"f5927b0ad3b59fb3","518":"6fc7b51f0d55b8d5","856":"868c236f3803f9ea"}[chunkId] + ".js";
};